
import { Component, Prop, Vue } from 'vue-property-decorator'
import ResultText from '@/components/organisms/study/ResultText.vue'
import ResultNumericalFormula from '@/components/organisms/study/ResultNumericalFormula.vue'
import ResultJapanese from '@/components/organisms/study/ResultJapanese.vue'
import ResultEnglish from '@/components/organisms/study/ResultEnglish.vue'
import { StudyModel } from '@/models/StudyModel'

/**
 * 設問情報の解答内容表示
 *   入力タイプごとにコンポーネントを切り替えるためのラッパーコンポーネント
 */
@Component({
  components: {
    ResultText,
    ResultNumericalFormula,
    ResultJapanese,
    ResultEnglish,
  },
})
export default class QuestionResultArea extends Vue {
  /** 設問情報 */
  @Prop()
  private question!: StudyModel.Question

  /** 正答を表示するかユーザ解答を表示するかのフラグ */
  @Prop({ default: false })
  private showCorrect!: boolean

  /**
   * 解答タイプに応じたコンポーネントを返す
   *
   * @returns 入力用コンポーネント名
   */
  private get componentType(): string {
    switch (this.question.answerFormatCode) {
      case StudyModel.ANSWER_FORMAT_CODE.INPUT:
        return 'ResultText'
      case StudyModel.ANSWER_FORMAT_CODE.NUMERICAL_FORMULA:
        return 'ResultNumericalFormula'
      case StudyModel.ANSWER_FORMAT_CODE.JAPANESE:
        return 'ResultJapanese'
      case StudyModel.ANSWER_FORMAT_CODE.ENGLISH:
        return 'ResultEnglish'
      // TODO: N_LMS-700 API実装後に択一式対応
    }
    // 一致しない場合、基本的に発生しない
    return ''
  }
}
